import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, length?: number) : string {
    let limit = length && length > 0 ? length : 10;

    return value.length > limit ? value.substring(0, limit) + '...' : value;
  }
}
